export const ROUTE_NAMES = {
  HOME: 'home',
  SERVICES: 'services',
  PROJECTS: 'projects',
  CONTACT: 'contact',
  NOUAR: 'nouar',
  AZAHAR: 'azahar',
  TOSSALET: 'tossalet',
  SIERRA: 'sierra',
  BELLAOMBRA: 'bellaombra',
  WABI_SABI: 'wabi-sabi',
  DASHBOARD: 'dashboard',
  SETTINGS: 'settings',
  PROFILE: 'profile',
  NOT_FOUND: 'not-found'
} as const

export type RouteNames = typeof ROUTE_NAMES[keyof typeof ROUTE_NAMES]